/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule, ReactiveFormsModule } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxInputComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxinput';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcInputComponent),
    multi: true
};

/**
 * Input
 */
@Component({
    selector: 'ngc-input',
    template: `<jqxInput *ngIf="visible"
                (onChange)="inputChange($event)"
                (onBlur)="inputTouched($event)"
                [disabled] = "disabled"
                [dropDownWidth] = "dropDownWidth"
                [displayMember] = "displayMember"
                [items] = "items"
                [minLength] = "minLength"
                [maxLength] = "maxLength"
                [opened] = "opened"
                [placeHolder] = "placeHolder"
                [popupZIndex] = "popupZIndex"
                [query] = "query"
                [renderer] = "renderer"
                [rtl] = "rtl"
                [searchMode] = "searchMode"
                [source] = "source"
                [theme] = "theme"
                [valueMember] = "valueMember"
                [value] = "value"
                [width] = "width"
                [height] = "height">
                </jqxInput>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class NgcInputComponent extends ControlComponent {
    @Input('dropDownWidth') dropDownWidth: any;
    @Input('displayMember') displayMember: any;
    @Input('items') items: any;
    @Input('minLength') minLength: any;
    @Input('maxLength') maxLength: any;
    @Input('opened') opened: any;
    @Input('placeHolder') placeHolder: any;
    @Input('popupZIndex') popupZIndex: any;
    @Input('query') query: any;
    @Input('renderer') renderer: any;
    @Input('rtl') rtl: any;
    @Input('searchMode') searchMode: any;
    @Input('source') source: any;
    @Input('theme') theme: any;
    @Input('valueMember') valueMember: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Input Change
     *
     * @param Event
     */
    inputChange($e) {
        this.value = $e.target.value;
    }

}

/**
 * Input Module
 */
@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NgcErrorModule],
    exports: [NgcInputComponent],
    declarations: [NgcInputComponent, jqxInputComponent]
})
export class NgcInputModule {
}